<app-header [eternalPage]="true"></app-header>

<section class="info">
  <h1 class="info__title">Diese Vorteile bringt der CHECK24 Kreditvergleich</h1>
  <ul class="info__list">
    <li class="list__item">
      <span class="icon-ok"></span>Kostenlose und unverbindliche
      Kreditvergleiche
    </li>
    <li class="list__item"><span class="icon-ok"></span>Kreditkosten sparen</li>
    <li class="list__item">
      <span class="icon-ok"></span>Professionelle Beratung
    </li>
  </ul>
  <button class="info__link" (click)="redirectPath()">
    Zum Kreditvergleich
  </button>
  <h2 class="info__subtitle">So bekommen Sie Ihren Wunschkredit</h2>

  <div class="info__block">
    <div class="block__item">
      <h3 class="item__title">Voraussetzungen</h3>
      <ul class="item__list">
        <li class="list__item">Volljährigkeit (mindestens 18 Jahre alt)</li>
        <li class="list__item">
          Hauptwohnsitz in Österreich seit mindestens 2 Jahren
        </li>
        <li class="list__item">Regelmäßiges Einkommen</li>
        <li class="list__item">Österreichisches Bankkonto</li>
        <li class="list__item">Positive Bonitätsbeurteilung (KSV oder CRIF)</li>
      </ul>
    </div>
    <div class="block__item">
      <h3 class="item__title">Erforderliche Unterlagen</h3>
      <ul class="item__list">
        <li class="list__item">Amtlicher Lichtbildausweis</li>
        <li class="list__item">Einkommensnachweis</li>
        <li class="list__item">ggf. Kontauszüge der letzten Monate</li>
        <li class="list__item">
          zusätzliche Unterlagen bei: Selbstständigkeit, Immobilien, Hausbau,
          Umschuldung, Autofinanzierung.
        </li>
      </ul>
    </div>
  </div>
  <div class="info__tip-wrap">
    <h2 class="info__tip-title">CHECK24-Tipp</h2>
    <p class="info__tip-text">
      Verbinden Sie Ihr CHECK24-Konto mit Ihrem Onlinebanking-Account. Dadurch
      müssen Sie Unterlagen wie z.B. Kontoauszüge nicht extra einreichen. Sie
      bekommen Ihren Wunschkredit damit noch schneller und einfacher.
    </p>
  </div>
  <h2 class="info__subtitle">Weitere Vorteile mit CHECK24</h2>
  <div class="info__accordion">
    <ng-container *ngFor="let item of benefit; let i = index">
      <div class="accordion__item">
        <button class="accordion__button" (click)="openAccordion($event)">
          <span class="text">{{ item.title }}</span
          ><span class="arrow down"></span>
        </button>
        <div class="accordion__panel">
          <p>{{ item.text }}</p>
        </div>
      </div>
    </ng-container>
  </div>
</section>
